(function () {
  const elLogin = document.querySelector('.js-login');
  const elRecoverModal = document.querySelector('.js-recover-modal');
  const elRecoverModalInner = document.querySelector('.js-recover-modal-inner');

  if (!elLogin || !elRecoverModal) return;

  function onHashChange() {
    const locationHash = window.location.hash;
    const isOnRecoverPage = locationHash === '#recover';
    toggleRecoverModal(isOnRecoverPage);
  }

  function toggleRecoverModal(isActive) {
    elRecoverModal.classList.toggle('is-active', isActive);

    if (isActive) {
      elRecoverModal.querySelector('input[type="email"]').focus();
    }
  }

  function init() {
    onHashChange();
    window.addEventListener('hashchange', () => {
      onHashChange();
    });

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        location.hash = '';
      }
    });

    window.addEventListener('click', (event) => {
      if (!elRecoverModal.classList.contains('is-active')) return;

      if (!elRecoverModalInner.contains(event.target) && event.target !== elRecoverModalInner) {
        location.hash = '';
      }
    });
  }

  init()
})();